<button [ngClass]="{outlineCheckbox: isOutlined,selctedOutline:isOutlined&&checked==true}">
    <mat-checkbox [disableRipple]="true" [(ngModel)]="checked" [formControl]="checkboxControl" [disabled]="disabled"
        (change)="checkedChange.emit($event.checked)" color="{{checkBoxColor}}" [labelPosition]="labelPosition">
        <p [style.color]="labelColor" [style.font-size]="labelFontSize" class="label {{labelClassName}}">{{label}}</p>
    </mat-checkbox>
</button>